import { ProductConfiguration } from '@/shared/models/ContextDataModel/interfaces/entities/product-configuration.ts';
import { CustomProduct } from '@/shared/forms/CustomProductsForm/schemas/getCustomProductsFormSchema.ts';
import { format } from 'date-fns';

export function getCustomProductsDefaultValues(
    productConfigurations: ProductConfiguration[] | undefined,
    defaultFallbacks?: ProductConfiguration[]
) {
    return (
        productConfigurations?.length
            ? productConfigurations
            : defaultFallbacks?.map(({ quantity: _, ...productConfiguration }) => productConfiguration)
    )
        ?.filter(hasPartnerOrganization)
        .map(
            productConfiguration =>
                ({
                    ...productConfiguration,
                    identifier: productConfiguration.id,
                    showZeroPurchasePrice: productConfiguration.showZeroPurchasePrice,
                    showZeroSalesPrice: productConfiguration.showZeroSalesPrice,
                    productName: productConfiguration.additionalProperties.name,
                    serviceDate: formatServiceDate(productConfiguration.serviceDate),
                    freightType:
                        'freightType' in productConfiguration.additionalProperties
                            ? productConfiguration.additionalProperties.freightType
                            : undefined,
                    disposalPurpose:
                        'disposalPurpose' in productConfiguration.additionalProperties
                            ? productConfiguration.additionalProperties.disposalPurpose
                            : undefined,
                }) as Partial<CustomProduct>
        );
}

function hasPartnerOrganization(
    productConfiguration: Pick<ProductConfiguration, 'partnerOrganizationId'>
): productConfiguration is ProductConfiguration & { partnerOrganizationId: number } {
    return !!productConfiguration.partnerOrganizationId;
}

function formatServiceDate(date?: Date): string | undefined {
    return date ? format(date, 'yyyy-MM-dd') : undefined;
}
